<template>
  <div>
    <spacer :y="5"/>
    <ul>
      <stack-item>
        <contents-box type="inner">
          <div :class="$style.regist">
            <p :class="$style.regist_title">組織登録</p>
            <basic-btn to="/operator/regist-school/">登録する</basic-btn>
          </div>
        </contents-box>
      </stack-item>

      <!-- <stack-item>
        <contents-box type="inner">
          <div :class="$style.regist">
            <p :class="$style.regist_title">学校管理者個別登録</p>
            <basic-btn to="/operator/regist-schoolUser/">登録する</basic-btn>
          </div>
        </contents-box>
      </stack-item> -->

      <stack-item>
        <contents-box title="組織一覧">
          <loader-simple :flag="flag.loader">
            <ul>
              <stack-item
                space="2"
                v-for="row in schools"
                :key="row.id"
                v-show="row.name !== 'old_id already exists'">
                <div :class="$style.wrap">
                  <label-box
                    :label="`ID:${row.id}`"
                    size="xs"
                    color="gray"
                    :class="$style.id" />
                  <!-- demoの場合のみflag: 1以外は非表示にする -->
                  <contents-box
                    type="inner"
                    :bg="row.flag !== 1 ? 'gray' : 'white'"
                    v-if="!(helper.env.name === 'demo' && row.flag !== 1)">
                    <div :class="$style.school">
                      <div>
                        <div :class="$style.kana">{{ row.kana }}</div>
                        <div :class="$style.name">{{ row.name }}</div>
                      </div>
                      <div :class="$style.icons">
                        <basic-btn
                          v-on:click="changeStatusFlag(row)"
                          tag="button"
                          type="bdr"
                          size="sm">{{ row.flag === 1 ? '非アクティブにする' : 'アクティブにする'}}</basic-btn>
                        <spacer :y="2" :class="$style.only_sp"/>
                        <router-link :to="`/operator/update-school/${row.id}`">
                          <i
                            v-if="openIds.includes(row.id)"
                            :class="$style.plus"
                            class="fa-solid fa-pen-to-square"></i>
                        </router-link>
                        <i
                          v-if="!openIds.includes(row.id)"
                          :class="$style.plus"
                          class="fa-solid fa-plus"
                          v-on:click="changeOpenIds(row.id);
                            getCountHistorys(row);
                            getBulkCountHistorys(row);
                            getSustainableAddCredit(row);
                            getTempcount(row);
                            getSchoolMemo(row)"/>
                        <i
                          v-if="openIds.includes(row.id)"
                          :class="$style.plus"
                          class="fa-solid fa-minus"
                          v-on:click="changeOpenIds(row.id)"/>
                      </div>
                    </div>

                    <ul
                      :class="$style.detail"
                      v-if="openIds.includes(row.id)">
                      <spacer :y="3"/>
                      <!-- アカウント課金の組織は本登録に必要な情報が異なるため、 -->
                      <li v-if="row.billing_type?.billing_type === 1">
                        <i :class="$style.icon" class="fa-solid fa-qrcode"></i>
                        <p :class="$style.content"><a :href="`${baseURL}/signup/?school=${row.id}`" target="_blank">{{ baseURL }}/signup/?school={{ row.id }}</a></p>
                      </li>
                      <li v-if="row.billing_type?.billing_type === 1">
                        <p :class="$style.content">
                          <img :src="`https://api.qrserver.com/v1/create-qr-code/?data=${baseURL}/signup?school=${row.id}&size=150x150`">
                        </p>
                      </li>
                      <li v-else>
                        <p v-if="row.registCount" :class="$style.regist_count">本登録
                          <span :class="$style.regist_count_num">{{ row.registCount }}<span :class="$style.regist_count_num_mini"> / {{ row.registCount + row.temporaryCount }}</span></span>名
                        </p>
                        <spacer :x="3" />
                        <p v-if="row.temporaryCount" :class="$style.regist_count">未登録
                          <span :class="$style.regist_count_num">{{ row.temporaryCount }}<span :class="$style.regist_count_num_mini"> / {{ row.registCount + row.temporaryCount }}</span></span>名
                        </p>
                      </li>
                      <!-- 契約年月日・法人名は学校管理者サイトの管理タブ（Teacher/tabs/QR.vue の契約情報
                           グループ）と同じグループ見出し・並び順に統一する（顧客指示）。契約名は顧客指示で
                           非表示化した（v-if ごと撤去・列とデータは残置）。住所/電話は組織側と契約担当者側の
                           2 組が同じ展開部に並ぶため、見出しで所属グループ・項目名（.field_label）で行を
                           特定させる。 -->
                      <li :class="$style.group_heading">契約情報</li>
                      <li>
                        <i :class="$style.icon" class="fa-solid fa-file-user"></i>
                        <p :class="$style.field_label">契約プラン</p>
                        <!-- billing_type 未設定（孤児/欠落校）は異常状態。正常な課金モデルとして見せず要確認マーカーを出す（#3233） -->
                        <p :class="$style.content" v-if="row.billing_type">
                          {{ helper.master.labels.schools.billing_type[row.billing_type?.billing_type] }}
                          <span :class="$style.ml_bold" v-if="row.billing_type?.billing_type === 1 && row.contract && row.contract.cycle">{{ row.contract.cycle === 1 ? '月次' : '年次' }}</span>
                          <!-- <span :class="$style.ml" v-if="row.billing_type?.billing_type === 2">心理士10回 医師2回</span> -->
                        </p>
                        <p :class="$style.content" v-else>⚠ 課金情報未登録（要確認）</p>
                        <!-- サステナブルプランのみ仮登録者の一括プリント出力ボタン -->
                        <p v-if="row.billing_type?.billing_type === 2">
                          <basic-btn
                            tag="a"
                            :size="'sm'"
                            :href="`/operator/print-bulk/${row.id}/`"
                            :target="'_blank'"
                            :style="'text-decoration: none;'">仮登録者プリント一括出力</basic-btn>
                        </p>
                      </li>
                      <li v-if="row.contract && row.contract.contract_date">
                        <i :class="$style.icon" class="fa-regular fa-calendar"></i>
                        <p :class="$style.field_label">契約年月日</p>
                        <p :class="$style.content">{{ contractDateLabelOf(row) }}</p>
                      </li>
                      <!-- 契約主体の名称は schools.corporate_name（法人名）を読む。schools.name は
                           「画面に出す名前」＝サイト表示名なので契約情報には出さない（一覧の見出しに出る
                           組織名・カナは看板表示なので name / kana のままでよい）。法人名が未登録の組織は
                           行ごと出さない（全組織が縦に並ぶ一覧のためノイズを増やさない）。 -->
                      <li v-if="row.corporate_name">
                        <i :class="$style.icon" class="fa-solid fa-building"></i>
                        <p :class="$style.field_label">法人名</p>
                        <p :class="$style.content">{{ row.corporate_name }}</p>
                      </li>
                      <!-- 住所・電話番号は「契約担当者」固有の連絡先（contractPerson）。下の管理者情報グループに
                           出る組織自身の住所/電話（schools.address / schools.tel）とは意味の異なる別項目なので、
                           見出しで所属グループ・項目名で行を特定させる。「管理者と同一」ON では契約担当者が組織側の
                           値へフォールバックして同値になるため、ON の間は行を出さない。空値でも「登録なし」で行を
                           残すのは登録状況を可視化するため（管理タブは行ごと消すので意図的に非対称。判定と文言は
                           contractPersonRowOf に寄せてある）。 -->
                      <li v-if="!contractPersonRowOf(row).sameAsAdmin">
                        <i :class="$style.icon" class="fa-regular fa-house"></i>
                        <p :class="$style.field_label">住所</p>
                        <p :class="$style.content">{{ contractPersonRowOf(row).addressText }}</p>
                      </li>
                      <li v-if="!contractPersonRowOf(row).sameAsAdmin">
                        <i :class="$style.icon" class="fa-solid fa-phone"></i>
                        <p :class="$style.field_label">電話番号</p>
                        <p :class="$style.content">{{ contractPersonRowOf(row).tel }}</p>
                      </li>
                      <li :class="$style.flexstart">
                        <label-box
                          :class="$style.label"
                          label="契約担当者"
                          size="xs" color="orange" />
                        <ul :class="$style.content_list">
                          <li>
                            <span>{{ contractPersonRowOf(row).name || '未登録' }}</span>
                            <span v-if="contractPersonRowOf(row).kana">（{{ contractPersonRowOf(row).kana }}）</span>
                            <span v-if="contractPersonRowOf(row).email">（<a :href="`mailto:${contractPersonRowOf(row).email}`">{{ contractPersonRowOf(row).email }}</a>）</span>
                            <span v-if="contractPersonRowOf(row).sameAsAdmin" :class="$style.same_as_admin">管理者と同一</span>
                            <div
                              v-for="f in contractPersonRowOf(row).attrs"
                              :key="f.label"
                              :class="[$style.kana, $style.full_width]">
                              {{ f.label }}: {{ f.value }}
                            </div>
                          </li>
                        </ul>
                      </li>
                      <!-- 管理者情報グループ。契約情報と同じ「見出し＋項目名つきの行」の作りに揃える
                           （学校管理者サイトの管理タブと同じ見出し・並び）。 -->
                      <li :class="$style.group_heading">管理者情報</li>
                      <!-- 組織区分バッジ（学校/インターン/企業）。orgTypeOf(row) で is_company/is_corporate から
                           3区分判定する（school_type[6]="企業" ラベルに依存せず、インターンの誤表示を回避）。
                           v-if/v-else-if/v-else で全区分を網羅し fall-through を作らない（バッジ欠落を防ぐ）。
                           項目名は値の出所に合わせて分ける: 学校分岐が出すのは校種なので「学校タイプ」
                           （管理タブと同語）、インターン/企業分岐が出すのは組織タイプそのものなので
                           「組織タイプ」（登録画面の見出し・Analytics のフィルタも同じ 2 軸で分けている）。 -->
                      <li v-if="orgTypeOf(row) === 0">
                        <i :class="$style.icon" class="fa-solid fa-graduation-cap"></i>
                        <p :class="$style.field_label">学校タイプ</p>
                        <p :class="$style.content">{{ helper.master.labels.schools.school_type[row.school_type] || '学校' }}</p>
                      </li>
                      <li v-else-if="orgTypeOf(row) === 1">
                        <i :class="$style.icon" class="fa-solid fa-user-graduate"></i>
                        <p :class="$style.field_label">組織タイプ</p>
                        <p :class="$style.content">インターン</p>
                      </li>
                      <li v-else>
                        <i :class="$style.icon" class="fa-solid fa-building"></i>
                        <p :class="$style.field_label">組織タイプ</p>
                        <p :class="$style.content">企業</p>
                      </li>
                      <!-- ここからは組織自身の連絡先（schools.tel / address）。契約担当者の連絡先は
                           上の契約情報グループに出るため、同じ展開部に住所/電話が 2 組並ぶ。どちらの連絡先かは
                           見出し（所属グループ）と項目名（.field_label）で読み分けさせる。
                           電話番号・住所は組織登録の必須項目なので、未登録でも行を残して「登録なし」を出し
                           欠落自体を可視化する（管理タブと同扱い）。並び順は管理タブ（Teacher/tabs/QR.vue）に
                           合わせて 住所 → 電話番号 とする。
                           組織のメールアドレス（schools.email）は顧客依頼で撤去した。実データは 2 組織にしか
                           無く、いずれも主管理者／契約担当者の欄に同じアドレスが出ている重複表示だったため
                           （列とデータは残置）。 -->
                      <li>
                        <i :class="$style.icon" class="fa-regular fa-house"></i>
                        <p :class="$style.field_label">住所</p>
                        <p v-if="row.address" :class="$style.content">
                          <!-- テンプレートに素の空白を書くとコンパイラ（whitespace: 'condense'）が
                               要素の先頭・末尾の空白のみのテキストノードを削除するため、区切りは空白を
                               書かずに出す。郵便番号の後は行ごとに桁を揃えたいので CSS margin（.zip）、
                               番地と建物名の間は 1 文字分でよいので補間に空白を含める。 -->
                          <span v-if="row.address.zip" :class="$style.zip">〒{{ row.address.zip }}</span>
                          <span>{{row.address.pref}}</span>
                          <span>{{row.address.city}}</span>
                          <span v-if="row.address.address">{{row.address.address}}</span>
                          <span v-if="row.address.building">{{ ' ' + row.address.building }}</span>
                        </p>
                        <p v-else :class="$style.content">登録なし</p>
                      </li>
                      <li>
                        <i :class="$style.icon" class="fa-solid fa-phone"></i>
                        <p :class="$style.field_label">電話番号</p>
                        <p :class="$style.content">{{ row.tel || '登録なし' }}</p>
                      </li>
                      <!-- <li v-if="row.fax">
                        <i :class="$style.icon" class="fa-solid fa-fax"></i>
                        <p :class="$style.content">{{ row.fax }}</p>
                      </li> -->
                      <li :class="$style.flexstart">
                        <label-box
                          :class="$style.label"
                          label="管理者"
                          size="xs" color="orange" />
                        <ul :class="$style.content_list">
                          <li
                            v-for="user in row.mainUser"
                            :key="user">
                            <span>{{ user.username }}</span>
                            <span v-if="user.kana && user.kana !== ''">（{{ user.kana }}）</span>
                            <span>（<a :href="`mailto:${user.email}`">{{ user.email }}</a>）</span>
                            <div :class="$style.message" class="fa-solid fa-messages" @click="messageDetail(user.id, row.id)">
                            </div>
                            <div
                              v-for="f in schoolAdminDisplay(mainSchoolAdmin(row, user.id), row)"
                              :key="f.label"
                              :class="[$style.kana, $style.full_width]">
                              {{ f.label }}: {{ f.value }}
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li
                        :class="$style.flexstart"
                        v-if="subAdminUsers(row).length">
                        <label-box
                          :class="$style.label"
                          label="副管理者"
                          size="xs" color="orange" />
                        <ul :class="$style.sub_admin_list">
                          <li v-for="user in subAdminUsers(row)"
                            :key="`${user._source}-${user.id}`">
                            <span>{{ user.username }}</span>
                            <span v-if="user.kana && user.kana !== ''">（{{ user.kana }}）</span>
                            <span v-if="user.email">（<a :href="`mailto:${user.email}`">{{ user.email }}</a>）</span>
                            <span :class="$style.status_badge_wrap">
                              <span :class="[$style.status_badge, $style[`status_${user.loginStatus}`]]">{{ loginStatusLabel(user.loginStatus) }}</span>
                              <span :class="$style.status_hint">
                                <i class="fa-regular fa-circle-question" :class="$style.status_hint_icon"></i>
                                <span :class="$style.status_tooltip">{{ loginStatusDetail(user.loginStatus) }}</span>
                              </span>
                            </span>
                            <div
                              v-for="f in schoolAdminDisplay(user, row)"
                              :key="f.label"
                              :class="[$style.kana, $style.full_width]">
                              {{ f.label }}: {{ f.value }}
                            </div>
                          </li>
                        </ul>
                      </li>
                      <!-- 見出しは本文（保有クレジット行）と同じく無条件で出す。オンライン・バーチャルの
                           クレジット行は課金区分に関係なく常に描画されるため、ゲートを付けると見出しだけが
                           条件付きになって整合しない。 -->
                      <li :class="$style.group_heading">オンライン・バーチャル健康相談</li>
                      <li>
                        <i :class="$style.icon" class="fa-solid fa-calculator"></i>
                        <p style="line-height: 1.2;">
                          保有クレジット <span :class="$style.bold">{{ schoolOnlineCredit(row) || 0 }}</span>
                          <span :class="$style.detailed_explanation"><br>※医師相談=２クレジット使用</span>
                        </p>

                        <spacer :x="3"/>
                        <div v-if="row.billing_type?.billing_type === 1">
                          <loader-simple :flag="flag.school_count.includes(row.id)" :mini="true" :isDisableMinHight="true">
                            <div v-if="!(flag.school_count.includes(row.id))">
                              <i
                                v-if="!countHistoryIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-plus"
                                v-on:click="changeOpenCountHistoryIds(row)"/>
                              <i
                                v-if="countHistoryIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-minus"
                                v-on:click="changeOpenCountHistoryIds(row)"/>
                            </div>
                          </loader-simple>
                        </div>
                      </li>

                      <div v-if="row.billing_type?.billing_type === 1 && countHistoryIds.includes(row.id)">
                        <div
                          v-for="(yearData) in countHistoriesGrouped(row.id)"
                          :key="yearData.year"
                          :class="$style.history_table_container">
                          <p>{{ yearData.year }}年</p>
                          <div :class="$style.history_table_wrap">
                            <div
                              v-for="(monthData) in yearData.monthDataList"
                              :key="monthData.month">
                              <div
                                :class="$style.history_table_toggle"
                                v-on:click="toggleOpenedList(`countHistory-${row.id}-${yearData.year}-${monthData.month}`)">
                                <p>{{ monthData.month }}月</p>
                                <i
                                  v-if="!openedList.includes(`countHistory-${row.id}-${yearData.year}-${monthData.month}`)"
                                  :class="$style.icon" class="fa-solid fa-plus"></i>
                                <i
                                  v-if="openedList.includes(`countHistory-${row.id}-${yearData.year}-${monthData.month}`)"
                                  :class="$style.icon" class="fa-solid fa-minus"></i>
                              </div>
                              <table
                                v-show="openedList.includes(`countHistory-${row.id}-${yearData.year}-${monthData.month}`)"
                                :class="$style.history_table">
                                <tr>
                                  <th v-for="count in countLabels" :key="count.label">{{ count.label }}</th>
                                </tr>
                                <tr
                                  v-for="history in monthData.histories"
                                  :key="history.id">
                                  <td
                                    v-for="count in countLabels"
                                    :key="count.label"
                                    :class="[$style[count.name]]">
                                    <p v-if="count.name === 'date'">{{ history.date }}</p>
                                    <p v-if="count.name === 'reserve_date'">{{ history.reserve_date }}</p>
                                    <!-- target は利用者名（自由入力の氏名）を含み HTML を埋める要件が無いため、v-html でなく補間でエスケープして描画する -->
                                    <p v-else-if="count.name === 'target'">{{ history.target }}</p>
                                    <p v-else-if="count.name === 'content'">{{ history.content }}</p>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div v-if="!countHistories[row.id] || !countHistories[row.id].length">
                          <p>回数使用・編集履歴は存在しません</p>
                        </div>
                      </div>

                      <!-- 見出しと本文（利用可能回数行）は同一の課金区分ゲートで括る（本文だけが条件付きだと
                           見出しが空振りする）。課金区分の対応は labels.json（schools.billing_type）が SoT。
                           オプショナルチェーンは課金未設定組織（billing_type 欠落）の実在に備える。 -->
                      <li v-if="row.billing_type?.billing_type === 1" :class="$style.group_heading">テキスト健康相談</li>
                      <li v-if="row.billing_type?.billing_type === 1">
                        <i :class="$style.icon" class="fa-sharp fa-light fa-abacus"></i>
                        <p style="line-height: 1.2;">
                          利用可能回数 <span :class="$style.bold">{{ schoolTextCredit(row) || 0 }}</span>
                        </p>
                        <spacer :x="3"/>
                        <div v-if="row.billing_type?.billing_type === 1">
                          <loader-simple :flag="flag.school_textCount.includes(row.id)" :mini="true" :isDisableMinHight="true">
                            <div v-if="!(flag.school_textCount.includes(row.id))">
                              <i
                                v-if="!countTextHistoryIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-plus"
                                v-on:click="changeOpenTextCountHistoryIds(row)"/>
                              <i
                                v-if="countTextHistoryIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-minus"
                                v-on:click="changeOpenTextCountHistoryIds(row)"/>
                            </div>
                          </loader-simple>
                        </div>
                      </li>

                      <div v-if="row.billing_type?.billing_type === 1 && countTextHistoryIds.includes(row.id)">
                        <div
                          v-for="(yearData) in countTextHistoriesGrouped(row.id)"
                          :key="yearData.year"
                          :class="$style.history_table_container">
                          <p>{{ yearData.year }}年</p>
                          <div :class="$style.history_table_wrap">
                            <div
                              v-for="(monthData) in yearData.monthDataList"
                              :key="monthData.month">
                              <div
                                :class="$style.history_table_toggle"
                                v-on:click="toggleOpenedList(`countTextHistory-${row.id}-${yearData.year}-${monthData.month}`)">
                                <p>{{ monthData.month }}月</p>
                                <i
                                  v-if="!openedList.includes(`countTextHistory-${row.id}-${yearData.year}-${monthData.month}`)"
                                  :class="$style.icon" class="fa-solid fa-plus"></i>
                                <i
                                  v-if="openedList.includes(`countTextHistory-${row.id}-${yearData.year}-${monthData.month}`)"
                                  :class="$style.icon" class="fa-solid fa-minus"></i>
                              </div>
                              <table
                                v-show="openedList.includes(`countTextHistory-${row.id}-${yearData.year}-${monthData.month}`)"
                                :class="$style.history_table">
                                <tr>
                                  <th v-for="count in textCountLabels" :key="count.label">{{ count.label }}</th>
                                </tr>
                                <tr
                                  v-for="history in monthData.histories"
                                  :key="history.id">
                                  <td
                                    v-for="count in textCountLabels"
                                    :key="count.label"
                                    :class="[$style[count.name]]">
                                    <p v-if="count.name === 'date'">{{ history.date }}</p>
                                    <!-- target は利用者名（自由入力の氏名）を含み HTML を埋める要件が無いため、v-html でなく補間でエスケープして描画する -->
                                    <p v-else-if="count.name === 'target'">{{ history.target }}</p>
                                    <p v-else-if="count.name === 'content'">{{ history.content }}</p>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div v-if="!countTextHistorys[row.id] || !countTextHistorys[row.id].length">
                          <p>回数使用・編集履歴は存在しません</p>
                        </div>
                      </div>

                      <!-- 以下の 2 ブロック（インポートcsv 利用回数 履歴／オンラインクレジット編集履歴）は
                           アカウント課金専用のオンライン系。直上の「テキスト健康相談」見出しとは課金区分で
                           排他描画されるため、画面上は「オンライン・バーチャル健康相談」見出しの配下に出る
                           （ソース順と描画グループが一致しないが、履歴テーブルの移動を避けてこの形にした）。 -->
                      <li v-if="row.billing_type?.billing_type === 2">
                        <i :class="$style.icon" class="fa-solid fa-clock-rotate-left"></i>
                        <p>インポートcsv 利用回数 履歴</p>
                        <spacer :x="3" />
                        <div>
                          <loader-simple :flag="flag.school_count.includes(row.id)" :mini="true" :isDisableMinHight="true">
                            <div v-if="!(flag.school_count.includes(row.id))">
                              <i
                                v-if="!bulkCountHistoryIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-plus"
                                v-on:click="changeOpenBulkCountHistoryIds(row)"/>
                              <i
                                v-if="bulkCountHistoryIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-minus"
                                v-on:click="changeOpenBulkCountHistoryIds(row)"/>
                            </div>
                          </loader-simple>
                        </div>
                      </li>

                      <li v-if="row.billing_type?.billing_type === 2 && bulkCountHistoryIds.includes(row.id)">
                        <div v-if="!bulkCountHistorys[row.id].length">変更履歴はありません</div>
                        <div v-else :class="[$style.categories, $style.max_width]">
                          <p :class="$style.content"><i :class="$style.icon" class="fa-solid fa-calculator-simple"></i>履歴</p>
                          <dl :class="$style.category">
                            <dt v-for="count in sustainableCountLabels" :key="count.label">
                              {{ count.label }}
                            </dt>
                          </dl>
                          <dl :class="$style.category"
                            v-for="history in bulkCountHistorys[row.id]" :key="history">
                            <dd
                              v-for="count in sustainableCountLabels"
                              :key="count.label">
                              <p v-if="count.name === 'date'">{{ history.date }}</p>
                              <p v-if="count.name === 'counselor_type'">{{ history.counselor_type }}</p>
                              <p v-if="count.name === 'content'">{{ history.content }}</p>
                              <p v-if="count.name === 'import_file'" :class="$style.width_break">{{ history.import_file }}</p>
                            </dd>
                          </dl>
                        </div>
                      </li>

                      <li v-if="row.billing_type?.billing_type === 2">
                        <i :class="$style.icon" class="fa-solid fa-square-plus"></i>
                        <p>オンラインクレジット編集履歴</p>
                        <spacer :x="3" />
                        <div>
                          <loader-simple :flag="flag.school_count.includes(row.id)" :mini="true" :isDisableMinHight="true">
                            <div v-if="!(flag.school_count.includes(row.id))">
                              <i
                                v-if="!susCreditIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-plus"
                                v-on:click="changeOpensusCreditIds(row)"/>
                              <i
                                v-if="susCreditIds.includes(row.id)"
                                :class="$style.count"
                                class="fa-solid fa-minus"
                                v-on:click="changeOpensusCreditIds(row)"/>
                            </div>
                          </loader-simple>
                        </div>
                      </li>

                      <li v-if="row.billing_type?.billing_type === 2 && susCreditIds.includes(row.id)">
                        <div v-if="!susCreditHistorys[row.id].length">変更履歴はありません</div>
                        <div v-else :class="[$style.categories, $style.max_width]">
                          <p :class="$style.content"><i :class="$style.icon" class="fa-solid fa-calculator-simple"></i>履歴</p>
                          <dl :class="$style.category">
                            <dt v-for="count in susCreditHistorysLabals" :key="count.label">
                              {{ count.label }}
                            </dt>
                          </dl>
                          <dl :class="$style.category"
                            v-for="history in susCreditHistorys[row.id]" :key="history">
                            <dd
                              v-for="count in susCreditHistorysLabals"
                              :key="count.label">
                              <p v-if="count.name === 'date'">{{ history.date }}</p>
                              <p v-if="count.name === 'editor'">{{ history.editor }}</p>
                              <p v-if="count.name === 'target'">{{ history.target }}</p>
                              <p v-if="count.name === 'content'">{{ history.content }}</p>
                              <p v-if="count.name === 'counselor_type'">{{ history.counselor_type }}</p>
                              <p v-if="count.name === 'credit'">{{ history.credit }}</p>
                            </dd>
                          </dl>
                        </div>
                      </li>

                      <!-- 医師心理士への共有メモ。
                           メモ 2 節は見出し（group_heading）を持たないため、直前の「テキスト健康相談」
                           見出しの配下に見えてしまう。区切り線を先頭行に付けてブロックの開始を示す
                           （共有メモ・内部メモは独立した v-if なので、線は「先に描画される方」に付ける）。 -->
                      <template v-if="row.schoolMemo && row.schoolMemo.features">
                        <li :class="[$style.flexstart, $style.group_separator]">
                          <i :class="$style.icon" class="fa-regular fa-note-sticky"></i>
                          <p>医師心理士への共有メモ</p>
                        </li>
                        <li class="n2br" :class="$style.flexstart_noTopMargin">
                          <p :class="$style.school_memo" class="multilineText">{{ row.schoolMemo.features }}</p>
                        </li>
                      </template>

                      <!-- 内部メモ。共有メモが描画されない組織ではこの行がメモ節の先頭になるので、
                           そのときだけ区切り線を引く（両方出るときに二重線にしない）。 -->
                      <li
                        :class="[$style.flexstart,
                                 !(row.schoolMemo && row.schoolMemo.features) ? $style.group_separator : '']"
                        v-if="row.schoolMemo && row.schoolMemo.memo">
                        <i :class="$style.icon" class="fa-regular fa-note-sticky"></i>
                        <p>メモ</p>
                      </li>
                      <li
                        class="n2br"
                        :class="$style.flexstart_noTopMargin"
                        v-if="row.schoolMemo && row.schoolMemo.memo">
                        <p :class="$style.school_memo" class="multilineText">{{ row.schoolMemo.memo }}</p>
                      </li>
                    </ul>
                  </contents-box>
                </div>
              </stack-item>
            </ul>
            <spacer :y="3"/>
          </loader-simple>
        </contents-box>
      </stack-item>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BasicBtn from '@/views/components/BasicBtn.vue';
import LabelBox from '@/views/components/LabelBox.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import moment from 'moment';
import saf from '@/mixins/schoolAdminFunctions';
import csm from '@/mixins/corporateSchool';
import { openPendingWindow, showInPendingWindow, closePendingWindow } from '@/lib/pendingWindow';

export default {
  name: 'operator-school-list',
  mixins: [saf, csm],
  components: {
    BasicBtn,
    LabelBox,
    ContentsBox,
    StackItem,
    LoaderSimple,
    Spacer,
  },
  data() {
    return {
      flag: {
        loader: true,
        countLoader: false,
        inputCsv: false,
        school_count: [],
        school_textCount: [],
      },
      schools: [],
      openIds: [],
      countHistories: {},
      countTextHistorys: {},
      bulkCountHistorys: {},
      susCreditHistorys: {},
      countHistoryIds: [],
      bulkCountHistoryIds: [],
      susCreditIds: [],
      countTextHistoryIds: [],
      countLabels: [
        {
          label: '申込日',
          name: 'date',
        },
        {
          label: '予約日（実施日）',
          name: 'reserve_date',
        },
        {
          label: '利用者・編集者',
          name: 'target',
        },
        {
          label: '内容',
          name: 'content',
        },
      ],
      textCountLabels: [
        {
          label: '受付日',
          name: 'date',
        },
        {
          label: '利用者・編集者',
          name: 'target',
        },
        {
          label: '内容',
          name: 'content',
        },
      ],
      sustainableCountLabels: [ // アカウント課金、登録初期に操作する調整履歴の方で使用
        {
          label: '編集日',
          name: 'date',
        },
        // {
        //   label: '編集者',
        //   name: 'regist_user_id',
        // },
        {
          label: '種別',
          name: 'counselor_type',
        },
        {
          label: '内容',
          name: 'content',
        },
        {
          label: '範囲',
          name: 'import_file',
        },
      ],
      susCreditHistorysLabals: [ // アカウント課金、クレジット付与の履歴、初期にやる利用可能回数一括調整とは別
        {
          label: '編集日',
          name: 'date',
        },
        {
          label: '編集者',
          name: 'editor',
        },
        {
          label: '対象',
          name: 'target',
        },
        {
          label: '種別',
          name: 'counselor_type',
        },
        {
          label: '内容',
          name: 'content',
        },
        {
          label: 'クレジット数',
          name: 'credit',
        },
      ],
      openedList: [], // 開いている`${type}-${学校ID}-${year}-${month}`のリスト
    };
  },
  created() {
    this.getSchools();
    console.log(this.helper.env);
  },
  computed: {
    ...mapState(['helper', 'user']),
    baseURL() {
      return `${location.protocol}//${location.host}`;
    },
    countHistoriesGrouped() {
      return (schoolId) => {
        const histories = this.countHistories[schoolId] ? JSON.parse(JSON.stringify(this.countHistories[schoolId])) : [];
        return this.getGroupedHistories(histories);
      };
    },
    countTextHistoriesGrouped() {
      return (schoolId) => {
        const histories = this.countTextHistorys[schoolId] ? JSON.parse(JSON.stringify(this.countTextHistorys[schoolId])) : [];
        return this.getGroupedHistories(histories);
      };
    },
  },
  methods: {
    /**
     * 副管理者一覧（subUsers 由来 + users(account_type=12) 由来を統合）
     * schoolAdmins テーブル経由で登録された副管理者を表示するために必要
     */
    subAdminUsers(row) {
      const merged = [];
      const now = moment();
      if (row && Array.isArray(row.subUser)) {
        row.subUser.forEach((s) => {
          merged.push({
            id: s.id,
            username: s.username,
            kana: s.kana,
            email: s.email,
            department: null,
            position: null,
            role: null,
            // subUsers 由来は「ログイン有効化リンク未送信（通知メールのみ運用）」→ not_sent と同表示
            loginStatus: 'not_sent',
            _source: 'subUsers',
          });
        });
      }
      if (row && Array.isArray(row.schoolAdmins)) {
        row.schoolAdmins.forEach((a) => {
          const u = a.user;
          if (u && Number(u.account_type) === 12 && Number(u.flag) === 1) {
            // ログイン状態の派生（School.vue / UpdateSchool.vue の mergedSubUsers と同ロジック）:
            //   available: password 設定済み → ログイン可能
            //   pending:   リンク送信済・期限内
            //   expired:   リンク送信済・期限切れ（要再送）
            //   not_sent:  未送信（expiry=NULL）
            const hasPassword = !!u.has_password;
            let loginStatus;
            if (hasPassword) loginStatus = 'available';
            else if (u.expiry && moment(u.expiry).isAfter(now)) loginStatus = 'pending';
            else if (u.expiry) loginStatus = 'expired';
            else loginStatus = 'not_sent';
            merged.push({
              id: u.id,
              username: u.username,
              kana: u.kana,
              email: u.email,
              department: a.department,
              position: a.position,
              role: a.role,
              loginStatus,
              _source: 'users',
            });
          }
        });
      }
      return merged;
    },
    /** ログインステータスのラベル文言（loginStatus → 表示文字列） */
    loginStatusLabel(status) {
      return ({
        available: 'ログイン可能',
        pending: '本人によるパスワード設定待ち',
        expired: 'リンク期限切れ・要再送',
        not_sent: 'リンク未送信',
      })[status] || '';
    },
    /** ログインステータスのホバー説明文言 */
    loginStatusDetail(status) {
      return ({
        available: 'パスワード設定済みで、本人がログインできる状態です。',
        pending: 'ログイン有効化リンクを送信済みです。本人がパスワードを設定するとログイン可能になります。',
        expired: '送信したログイン有効化リンクの有効期限が切れています。リンクを再送してください。',
        not_sent: 'ログイン有効化リンクが未送信です。リンクを送信すると本人がパスワードを設定できます。',
      })[status] || '';
    },
    /** 主管理者の schoolAdmins 行を取得（所属/職階/役割 表示用） */
    mainSchoolAdmin(row, userId) {
      if (!row || !Array.isArray(row.schoolAdmins)) return null;
      return row.schoolAdmins.find((a) => a.user_id === userId) || null;
    },
    /** schoolAdmins レコード（または merged 行）から表示用 {label, value} 配列を生成（空値は除外）。
     *  フィールド定義は mixin schoolAdminFieldDefs(is_company, school_type) を行ごとに引く */
    schoolAdminDisplay(source, row) {
      if (!source) return [];
      return this.schoolAdminFieldDefs(row.is_company, row.school_type)
        .map((f) => ({ label: f.label, value: source[f.name] }))
        .filter((x) => x.value && String(x.value).trim() !== '');
    },
    /** 契約担当者の表示行。schools.contract_same_as_admin!=0（既定・contractPerson 行なし含む）は
     *  主管理者の情報を代替表示し「管理者と同一」バッジを付ける（QR.vue の contractPersonRow と同判定）。
     *  部署/職階は contractPersonAttrs（固定 2 列・役割なし）で出す。ON のときも管理者の値を
     *  この固定ラベルで並べる — 契約担当者としての呼称は組織種類にも表示元にもよらないため
     *  （直上の管理者行は従来どおり種別別ラベル＋役割で、そちらは schoolAdminDisplay のまま）。
     *  email は「管理者と同一」ON でも出す（学校管理者サイトの管理タブと同扱い。隣の「管理者と同一」
     *  バッジが同値である旨を明示するので、直上の管理者行と同じ値でも説明のつかない重複にならない）。
     *  住所・電話番号は OFF のときだけ出す — ON では組織行に同値が既出で、独立した項目行として重複が
     *  視認距離内に並ぶため。email は人物行（管理者/副管理者行と同意匠）、住所・電話番号は独立行
     *  （テンプレート側の li）に載せる */
    contractPersonRowOf(row) {
      const sameAsAdmin = Number(row.contract_same_as_admin) !== 0;
      if (sameAsAdmin) {
        const main = Array.isArray(row.mainUser) && row.mainUser.length ? row.mainUser[0] : null;
        const pivot = main ? this.mainSchoolAdmin(row, main.id) : null;
        return {
          name: main ? main.username : null,
          kana: main ? main.kana : null,
          email: (main && main.email) || null,
          attrs: this.contractPersonAttrs(pivot),
          addressText: null,
          tel: null,
          sameAsAdmin: true,
        };
      }
      const cp = row.contractPerson;
      // 住所は 〒zip / 都道府県+市区町村+番地（詰め連結）/ 建物名 の 3 パートを空値除去して
      // 半角スペースで区切る。区切りを JS 連結（補間結果）で出すのは、テンプレート素書きの空白が
      // コンパイラ（whitespace: 'condense'）に削除されるため。QR.vue の住所行と同趣旨の区切り
      // （あちらは複数の住所行の桁を揃えるため zip 後を CSS margin で固定している）
      const addressText = cp ? [
        cp.zip ? `〒${cp.zip}` : null,
        [cp.pref, cp.city, cp.address].filter(Boolean).join(''),
        cp.building,
      ].filter((part) => part && String(part).trim() !== '').join(' ') : '';
      const attrs = this.contractPersonAttrs(cp);
      // 住所・電話番号は空でも「登録なし」で行を残す。事務局はこの一覧で組織ごとの登録状況を確認する
      // ため、行が消えると「未登録なのか項目自体が無いのか」を区別できない（attrs 既存の「空値は除外」
      // とは非対称だが、契約担当者の連絡先は登録を求めている情報なので欠落を可視化する側に倒す）。
      // 全組織が縦に並ぶ一覧では「登録なし」が目立つが、欠落の把握を優先する要件で決着している。
      // 学校管理者サイトの管理タブは値が無ければ電話行ごと消すが、こちらは意図的に揃えない
      // （あちらは 1 組織だけを見る画面で、こちらは登録状況の確認が用途）。
      const orNashi = (v) => (v && String(v).trim() !== '' ? v : '登録なし');
      return {
        name: (cp && cp.name) || null,
        kana: (cp && cp.kana) || null,
        email: (cp && cp.email) || null,
        attrs,
        addressText: orNashi(addressText),
        tel: orNashi(cp && cp.tel),
        sameAsAdmin: false,
      };
    },
    /** 契約年月日の表示整形。contracts.contract_date は ISO-UTC で届くため、端末のタイムゾーンで
     *  日付がずれないよう utcOffset(540) で JST 固定してから整形する（学校管理者サイトの管理タブと同値）。
     *  v-for の行ごとに対象が変わるので computed ではなく method で持つ */
    contractDateLabelOf(row) {
      if (!row || !row.contract || !row.contract.contract_date) return '';
      return moment(row.contract.contract_date).utcOffset(540).format('YYYY年MM月DD日');
    },
    getSchools() {
      const params = {
        includeDeleted: 1,
        isMainUser: 1,
        isUsers: 0,
      };
      this.axios({
        method: 'GET',
        url: '/v1/school/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.schools = res.data.data;
          this.schools.forEach((school) => {
            this.flag.school_count.push(school.id);
            this.flag.school_textCount.push(school.id);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.massage);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loader = false;
        });
    },

    async getCountHistorys(target) {
      if (!target.billing_type) return; // billing_type 未設定（孤児/欠落校）は履歴 API を撃たない（#3233）
      this.axios({
        method: 'GET',
        url: '/v1/count/history/get/list',
        params: {
          foreign_id: target.id,
          billing_type: target.billing_type?.billing_type,
          withReserve: 1,
          orderBy: 'asc',
        },
      })
        .then((response) => {
          // this.schoolで該当の学校の情報に付与
          const res = response.data.countHistories;
          const index = this.schools.findIndex((elem) => elem.id === target.id);
          this.schools[index].countHistories = res.data;
          this.sortCountHistories();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });

      this.axios({
        method: 'GET',
        url: '/v1/count/historyText/get/list',
        params: {
          school_id: target.id,
          billing_type: target.billing_type?.billing_type,
          withMessageGroup: 1,
          orderBy: 'asc',
        },
      })
        .then((response) => {
          const res = response.data.textCountHistories;
          const index = this.schools.findIndex((elem) => elem.id === target.id);
          this.schools[index].textCountHistories = res.data;
          this.sortTextCountHistories();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    sortCountHistories() {
      this.schools.forEach((school) => {
        if (school.countHistories && school.countHistories.length) {
          this.countHistories[school.id] = [];
          school.countHistories.forEach((count) => {
            if (count.count) {
              let contentLabel;
              if (count.is_add) contentLabel = '追加';
              else if (!count.is_add && !count.reserve_id) contentLabel = '削除';
              else contentLabel = '使用';

              const insertData = {
                date: moment(count.updated_at).format('YYYY年MM月DD日'),
                dateRaw: count.updated_at,
                target: count.reserve_id && count.reserve && count.reserve.fromUser ? count.reserve.fromUser.username : '事務局',
                content: `${count.count}クレジット ${contentLabel}`,
                // detail: count,
                reserve_date: count.reserve_id && count.reserve && count.reserve.schedule ? moment(count.reserve.schedule.date).format('YYYY年MM月DD日') : '',
              };
              this.countHistories[school.id].push(insertData);
            }
          });

          const index = this.flag.school_count.findIndex((elem) => elem === school.id);
          this.flag.school_count.splice(index, 1);
        }
      });
    },

    sortTextCountHistories() {
      this.schools.forEach((school) => {
        if (school.textCountHistories && school.textCountHistories.length) {
          this.countTextHistorys[school.id] = [];
          school.textCountHistories.forEach((count) => {
            if (count.count) {
              let contentLabel;
              if (count.is_add) contentLabel = '追加';
              else if (!count.is_add && !count.group_id) contentLabel = '削除';
              else contentLabel = '使用';

              const insertData = {
                date: moment(count.updated_at).format('YYYY年MM月DD日'),
                dateRaw: count.updated_at,
                target: '事務局',
                content: `${count.count}回${contentLabel}`,
              };
              if (count.messageGroup && count.messageGroup.customer) insertData.target = count.messageGroup.customer.username;
              this.countTextHistorys[school.id].push(insertData);
            }
          });
          const index = this.flag.school_textCount.findIndex((elem) => elem === school.id);
          this.flag.school_textCount.splice(index, 1);
        }
      });
    },

    // アカウント課金タイプの契約の初期回数調整履歴を取得
    async getBulkCountHistorys(target) {
      if (!target.billing_type || target.billing_type.billing_type === 1) return true; // 未設定（孤児校）or 従量課金契約は即返却（#3233）

      const params = {
        school_id: target.id,
        isImport: 1,
      };

      this.axios({
        method: 'GET',
        url: '/v1/bulkCount/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.data.data;
          const index = this.schools.findIndex((school) => school.id === target.id);
          this.flag.school_count.splice(index, 1);
          this.bulkCountHistorys[target.id] = [];
          res.forEach((data) => {
            const insertData = {
              date: moment(data.created_at).format('YYYY年MM月DD日'),
              counselor_type: data.counselor_type === 21 ? '医師' : '心理士',
              import_file: data.import ? data.import.name : '全体',
              content: `${data.count}回${data.is_add ? '追加' : '削除'}`,
            };
            this.bulkCountHistorys[target.id].push(insertData);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    /**
     * アカウント課金タイプのオンラインクレジット付与履歴を取得
     * 表示するのは
     * 事務局→学校クレジット
     * 事務局→利用者クレジット
     * 学校→利用者クレジット
    */
    async getSustainableAddCredit(target) {
      if (!target.billing_type || target.billing_type.billing_type === 1) return true; // 未設定（孤児校）or 学校タイプが従量課金は即返却（#3233）

      const params = {
        school_id: target.id,
        isUsers: 1,
        isSchool: 1,
        isTargetUser: 1,
      };

      this.axios({
        methods: 'GET',
        url: '/v1/sustainableAddCredit/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.data.data;
          const index = this.schools.findIndex((school) => school.id === target.id);
          this.flag.school_count.splice(index, 1);
          this.susCreditHistorys[target.id] = [];
          res.forEach((data) => {
            const insertData = {
              date: moment(data.created_at).format('YYYY年MM月DD日'),
              dateRaw: data.created_at,
              editor: data.regist_user.account_type === 31 ? '事務局' : data.regist_user.username,
              target: data.target_user_id ? data.target_user.username : data.school.name,
              content: `${data.credit}クレジット${data.is_add ? '追加' : '削除'}`,
              credit: `${data.credit}クレジット`,
              is_add: data.is_add,
              counselor_type: 'なし',
            };
            if (data.counselor_type) { // カウンセラータイプNULLになるのは事務局→学校のパターンのみ
              insertData.counselor_type = data.counselor_type === 22 ? '心理士' : '医師';
              const count = data.counselor_type === 22 ? data.credit : data.credit / 2; // 回数表記用
              insertData.content = `${count}回${data.is_add ? '追加' : '削除'}`;
            }
            this.susCreditHistorys[target.id].push(insertData);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error.message);
        });
    },

    // アカウント課金の仮登録、本登録の人数を返却
    async getTempcount(school) {
      // 未設定（孤児校）or 従量課金タイプだったら即返却（#3233）
      if (!school.billing_type || school.billing_type.billing_type === 1) return true;

      const params = { school_id: school.id };
      this.axios({
        method: 'GET',
        url: '/v1/user/get/tempCount',
        params,
      })
        .then((response) => {
          const res = response.data.result;
          const target = this.schools.find((elem) => elem.id === school.id);
          target.temporaryCount = res.temporary;
          target.registCount = res.regist;
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    // 学校に対するメモがある場合は学校メモも取得
    async getSchoolMemo(school) {
      const params = { school_id: school.id };

      this.axios({
        method: 'GET',
        url: '/v1/schoolMemo/get/detail',
        params,
      })
        .then((response) => {
          if (response.data.detail.data.length) {
            const res = response.data.detail.data[0];
            const targetSchoolIndex = this.schools.findIndex((elem) => elem.id === school.id);
            this.schools[targetSchoolIndex].schoolMemo = res;
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    sortUser() {
      const type = [11, 12];
      this.schools.forEach((row) => {
        const manageUser = [];
        row.users.forEach((user) => {
          if (type.includes(user.account_type)) {
            manageUser.push(user);
          }
        });
        row.users = manageUser;
      });
      this.flag.loader = false;
    },

    changeOpenIds(id) {
      if (this.openIds.includes(id)) {
        const idx = this.openIds.indexOf(id);
        this.openIds.splice(idx, 1);
      } else {
        this.openIds.push(id);
      }
    },

    changeOpenCountHistoryIds(row) {
      if (this.countHistoryIds.includes(row.id)) {
        const idx = this.countHistoryIds.indexOf(row.id);
        this.countHistoryIds.splice(idx, 1);
      } else {
        this.countHistoryIds.push(row.id);
      }
    },

    changeOpenTextCountHistoryIds(row) {
      if (this.countTextHistoryIds.includes(row.id)) {
        const idx = this.countTextHistoryIds.indexOf(row.id);
        this.countTextHistoryIds.splice(idx, 1);
      } else {
        this.countTextHistoryIds.push(row.id);
      }
    },

    async changeOpenBulkCountHistoryIds(row) {
      if (this.bulkCountHistoryIds.includes(row.id)) {
        const idx = this.bulkCountHistoryIds.indexOf(row.id);
        this.bulkCountHistoryIds.splice(idx, 1);
      } else {
        this.bulkCountHistoryIds.push(row.id);
      }
    },

    async changeOpensusCreditIds(row) {
      if (this.susCreditIds.includes(row.id)) {
        const idx = this.susCreditIds.indexOf(row.id);
        this.susCreditIds.splice(idx, 1);
      } else {
        this.susCreditIds.push(row.id);
      }
    },

    changeStatusFlag(school) {
      const label = school.flag === 1 ? '非アクティブ' : 'アクティブ';
      if (!confirm(`この組織を${label}してよろしいですか？\n${school.name}`)) return;
      const data = {
        id: school.id,
        flag: school.flag === 1 ? 999 : 1,
      };

      this.axios({
        method: 'POST',
        url: '/v1/school/set/updater',
        data,
      })
        .then(() => {
          this.getSchools();
          alert(`${label}化が完了しました。`);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },
    messageDetail(targetUserId, schoolId) {
      const ownUserId = this.user.id;
      if (!targetUserId || !ownUserId || !schoolId) return;
      // SchoolList の宛先は常に学校の主管理者(11) ＝学校共有ルーム(target_type=4)へルーティング（#3185 D・事務局起点）。
      // backend の find-or-create（target_type=4 + school_id）に委譲し、既存/新規いずれも group_id を受け取って開く。
      // 主↔副↔事務局が同一スレッドを相互閲覧できる。
      const data = {
        user_id: ownUserId, // backend 側で type=4 は user_id=事務局(1) に正規化される
        target_type: 4,
        school_id: schoolId,
      };
      // 応答を待ってから開くとブラウザにポップアップとして止められることがあるので、押した瞬間にタブを開いておく
      const messageWindow = openPendingWindow();

      this.axios({
        method: 'POST',
        url: '/v1/messageGroup/set/register',
        data,
      })
        .then((response) => {
          const res = response.data;
          const resolvedRoute = this.$router.resolve({
            name: 'OperatorMessageDetail',
            params: { slug: res.group_id },
          });
          showInPendingWindow(messageWindow, resolvedRoute.href);
        })
        .catch((error) => {
          closePendingWindow(messageWindow);
          if (error.message) console.log(error.message);
          else console.log(error);
          alert('メッセージの初期化に失敗しました。');
        });
    },
    /**
     * 学校の保持オンラインクレジット
     *   該当校の課金タイプが
     *     1 => 従量課金: school.count
     *     2 => アカウント課金: school.mainUser[0].count.credit
     */
    schoolOnlineCredit(school) {
      const billingType = school.billing_type?.billing_type;
      let credit = 0;
      if (billingType === 1) credit = school.count;
      else if (billingType === 2) credit = school.mainUser[0].count.credit;
      return credit;
    },
    /**
     * 学校のテキスト利用可能回数
     * 従量課金のみ: school.textCount
     */
    schoolTextCredit(school) {
      const billingType = school.billing_type?.billing_type;
      let credit = 0;
      if (billingType === 1) credit = school.textCount;
      return credit;
    },

    toggleOpenedList(key) {
      if (this.openedList.includes(key)) {
        const idx = this.openedList.indexOf(key);
        this.openedList.splice(idx, 1);
      } else {
        this.openedList.push(key);
      }
    },

    getGroupedHistories(histories) {
      const groupedData = [];
      // [
      //   {
      //     year: '2023',
      //     monthDataList: [
      //       {
      //         month: '1',
      //         histories: []
      //       },
      //       {
      //         month: '2',
      //         histories: []
      //       },
      //     ]
      //   },
      //   {
      //     year: '2024',
      //     monthDataList: [
      //       ...
      histories.sort((a, b) => moment(b.dateRaw, 'YYYY-MM-DD HH:mm:ss').diff(moment(a.dateRaw, 'YYYY-MM-DD HH:mm:ss'))); // 降順にソート
      histories.forEach((history) => {
        const date = moment(history.date, 'YYYY年MM月DD日');
        const year = date.format('YYYY');
        const month = date.format('M');

        let monthDataList = groupedData.find((data) => data.year === year);
        if (!monthDataList) {
          monthDataList = { year, monthDataList: [] };
          groupedData.push(monthDataList);
        }
        let monthData = monthDataList.monthDataList.find((data) => data.month === month);
        if (!monthData) {
          monthData = { month, histories: [] };
          monthDataList.monthDataList.push(monthData);
        }
        monthData.histories.push(history);
      });
      return groupedData;
    },
  },
};
</script>

<style lang="scss" module>
.regist {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_title {
    font-size: 20px;
    font-weight: bold;
  }

  @include sm-view {
    display: block;
  }
}
.wrap {
  position: relative;
}
.id {
  position: absolute;
  z-index: 1;
  width: 120px;
  margin: 12px 0 0 -6px;
}
.kana {
  font-size: 12px;
}
// 契約担当者が主管理者と同一である旨のバッジ（QR.vue と同意匠）
.same_as_admin {
  font-size: 11px;
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 4px;
  background-color: var(--gray-sub);
  color: var(--black);
}
.name {
  font-size: 16px;
  @include sm-view {
    font-size: 14px;
  }
}
.school {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;

  @include sm-view {
    margin-top: 40px;
    display: block;
  }
}
.icons {
  display: flex;
  align-items: center;
  @include sm-view {
    display: block;
    margin-top: 10px;
    text-align: right;
  }
}
.plus {
  cursor: pointer;
  font-size: 20px;
  color: var(--gray-side);
  margin-left: 20px;
}
.count {
  cursor: pointer;
  font-size: 20px;
  color: var(--gray-side);
  display: flex;
}
// .read_csv {
//   display: block;
//   padding: 3%;
//   text-align: center;
//   background-color: var(--gray-sub);
//   border-radius: 5px;
//   button {
//     margin-top: 10px;
//   }
// }
// .file_input:hover {
//   cursor: pointer;
// }
.detail {
  li {
    display: flex;
    align-items: center;
    // モバイル幅で block に落とすかは学校管理者サイトの管理タブと非対称（あちらは block）。
    // 意図が確認できるまで既存のコメントアウトのまま据え置く。
    @include sm-view {
      // display: block;
    }
    &.flexstart {
      align-items: flex-start;
      &_noTopMargin {
        margin-top: -15px;
      }
    }
    // グループ（契約情報 / 管理者情報 / 相談種別）の小見出し。上の区切り線とセットでグループの開始を示す。
    // 前グループの終端線も兼ねるため、行側に下罫線を持たせない（重ねると二重線になる）
    &.group_heading {
      display: block;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid var(--gray-main);
      font-weight: bold;
    }
    // 見出しを持たないブロック（メモ節）の開始を示す区切り線。罫線・余白は group_heading と同値だが、
    // display / font-weight は指定しない（.flexstart の整形をそのまま活かすため）。
    // これが無いとメモ節が直前の「テキスト健康相談」見出しの配下に見える（相談種別の属性と誤読される）。
    &.group_separator {
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid var(--gray-main);
    }
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    // アイコンは字種ごとに実グリフ幅が違うため、素のままだと後続の項目名・値の x 位置が行ごとにずれる
    // （実測: 同一カードでラベル左端が 201〜211px と 10px ばらついた）。fa-fw と同じ 1.25em で固定し、
    // 中央寄せして縦に揃える（学校管理者サイトの管理タブと同じ対処）。
    .icon {
      display: inline-block;
      width: 1.25em;
      text-align: center;
      font-size: 20px;
      color: var(--orange-main);
      margin-right: 10px;
    }
    // 属性行の項目名。同じ展開部に住所/電話が 2 組（組織自身と契約担当者）並ぶため、行の identity は
    // アイコンではなくこの項目名で示す。幅・字送りは学校管理者サイトの管理タブと同値にして読み口を揃える。
    // 人物行（管理者/副管理者/契約担当者）は項目名でなくバッジ(.label)で種別を示すので、こちらは持たない
    .field_label {
      width: 96px;
      white-space: nowrap;
      margin-right: 10px;
      font-size: 13px;
      color: var(--gray-side);
    }
    .label {
      // 「契約担当者」(5文字・xs) が 60px では収まらないため QR.vue と同じ 72px に拡大
      width: 72px;
      white-space: nowrap;
      margin-right: 10px;
    }
    .content {
      &_block {
        display: block;
      }
      flex: 1;
      // 郵便番号と住所文字列の間を 1 マス空ける。テキスト側の半角スペースだと字形・フォント依存で
      // 幅が変わり、行によって間隔が揃わないため margin で 1rem に固定する。
      .zip {
        margin-right: 1rem;
      }
      &_list {
        @include sm-view {
          font-size: 14px;
        }
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        li {
          display: flex;
          flex-wrap: wrap;
          &:not(:last-child) {
            margin-bottom: 0;
            &::after {
              content: '/';
              padding: 0 10px;
            }
          }
        }
      }
      .ml {
        margin-left: 1em;
        &_bold {
          font-weight: bold;
        }
      }
      @include sm-view {
        font-size: 14px;
      }
    }
  }
  a {
    color: var(--black);
    text-decoration: underline;
    transition: all .4s;
    &:hover {
      opacity: .6;
    }
  }
}
.regist_count{
  font-size: 1.1em;
  font-weight: bold;
  &_num {
    font-size: 1.3em;
    &_mini {
      font-size: 15px;
    }
  }
}
.bold {
  font-weight: bold;
}
.center {
  text-align: center;
}
.inactive {
  font-size: 12px;
  padding: 2px 12px;
  border-radius: 12px;
  border: 1px solid var(--black);
  cursor: pointer;
}
.only_pc {
  @include sm-view {
    display: none;
  }
}
.only_sp {
  display: none;
  @include sm-view {
    display: block;
  }
}
.detailed_explanation{
  font-size: .7em;
}
.categories {
  $mgn: 40px;
  $gry: #ccc;
  $bdr: 1px solid $gry;
  $pd: .5em;
  width: 75%;
  .category {
    font-size: .8em;
    padding: $mgn/5 0;
    border-bottom: $bdr;
    display: flex;
    margin-block-start: 0;
    margin-block-end: 0;
    // width: 90%;
    &:first-child {
      border-top: $bdr;
    }
     > dt, dd {
      padding: 0 $pd;
      margin-inline-start: 0;
    }
   > dt {
      width: 45%;
    }
    > dd {
      flex: 1;
    }
    .link {
      margin-left: auto;
      padding-left: 1em;
    }
    .width_break {
      word-break: break-word;
    }
  }

  &.max_width {
    width: 100%;
  }
}
.message {
  margin-left: 5px;
  color: var(--gray-side);
  cursor: pointer;
}
.school_memo {
  padding: .7em;
  border-radius: 12px;
  background-color: var(--gray-sub);
}

// 副管理者一覧：1副管理者の内訳は主管理者(content_list)と同じ flex 並列。
// 複数副管理者間は `/` 区切りではなく改行 + 行間で表現。
.sub_admin_list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-basis: 100%;
    &:not(:last-child) {
      margin-bottom: 12px;
      &::after {
        content: none;
      }
    }
  }
}

// flex 親内で要素を強制的に次行へ折り返す（主管理者の所属/職階/役割 行用）
.full_width {
  flex-basis: 100%;
}

.history_table_container {
  display: flex;
  white-space: nowrap;
  margin-left: 2rem;
  .history_table_wrap {
    margin-left: 10px;
    flex-basis: 100%;
    flex-direction: column;
  }
  .history_table_toggle {
    display: flex;
    cursor: pointer;
    color: var(--orange-main);
    margin-bottom: 5px;
    align-items: center;
  }
  .history_table {
    // categoriesのスタイルを踏襲
    width: 100%;
    font-size: .8em;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 1rem;
    th {
      font-weight: normal;
      font-size: .9em;
      text-align: left;
      border-bottom: 1px solid #ccc;
    }
    td {
      text-align: left;
      border-bottom: 1px solid #ccc;
      &.date, &.reserve_date {
        width: 8rem;
      }
      &.target {
        width: 12rem;
        white-space: wrap;
      }
    }
  }
}

// 副管理者のログインステータスバッジ（School.vue / UpdateSchool.vue と同デザイン）
.status_badge_wrap {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  vertical-align: middle;
}
.status_badge {
  display: inline-block;
  font-size: .75em;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
}
// ホバーで詳細を表示する旨を `?` アイコンで明示（PJ 慣行: fa-circle-question + cursor:help）
.status_hint {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
  &:hover .status_tooltip {
    visibility: visible;
    opacity: 1;
  }
}
.status_hint_icon {
  font-size: 13px;
  color: #888;
}
.status_tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 240px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  color: #fff;
  background-color: #333;
  border-radius: 6px;
  white-space: normal;
  transition: opacity 0.2s;
  z-index: 10;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #333;
  }
}
.status_available {
  color: #fff;
  background-color: var(--green-main);
}
.status_pending {
  color: #fff;
  background-color: var(--blue-main);
}
.status_expired {
  color: #fff;
  background-color: var(--orange-main);
}
.status_not_sent {
  color: var(--black);
  background-color: var(--gray-sub);
}
</style>
